import { render, staticRenderFns } from "./ChangeHistoryTable.vue?vue&type=template&id=96567858&scoped=true&"
import script from "./ChangeHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ChangeHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ChangeHistoryTable.vue?vue&type=style&index=0&id=96567858&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96567858",
  null
  
)

export default component.exports